<wl-partial-media-card
  [grow]="cardConfig?.stretchVertical"
  [shadow]="cardConfig?.shadow"
  [theme]="settings?.theme"
>
  @if (displayImage(settings?.variant, image)) {
    <wl-partial-image
      [src]="image?.image?.src"
      [alt]="image?.image?.alt"
      [ratio]="'4/3'"
      [objectPosition]="image?.position"
      [objectFit]="image?.objectFit"
    >
    </wl-partial-image>
  }
  <wl-partial-structured-content
    [class.p-md-4]="context?.colWidth >= 6"
    [class.p-md-3]="context?.colWidth === 4"
    [class.p-2]="true"
    [layoutButtonsInline]="context?.colWidth > 6"
  >
    @if (settings?.icon?.name) {
      <fa-icon
        slot="icon"
        [icon]="settings?.icon?.name"
        [class.icon-lg-md]="context?.colWidth >= 6"
        [class.icon-md]="true"
      >
      </fa-icon>
    }
    @if (content?.heading?.text?.value) {
      <ng-container slot="heading">
        <h3
          class="mb-0"
          [class.h2-md]="context?.colWidth >= 6"
          [class.h3-md]="context?.colWidth === 4"
          [class.h4]="true"
          *scText="content.heading.text"
        ></h3>
      </ng-container>
    }
    @if (content?.subheading?.text?.value) {
      <ng-container slot="subheading">
        <h4 class="intro" *scText="content.subheading.text"></h4>
      </ng-container>
    }
    <ng-container slot="paragraph">
      @if (content?.text?.text?.value) {
        <wl-rich-text-wrapper [field]="content?.text?.text">
          <p class="mb-0"></p>
        </wl-rich-text-wrapper>
      }
    </ng-container>
    @if (content?.buttons?.primary?.link?.href) {
      <ng-container slot="button-primary">
        <wl-partial-button
          role="link"
          [theme]="primaryButtonTheme"
          [fullWidth]="true"
          [context]="settings.context"
          [ngClass]="content.buttons.primary.link.class"
          [href]="content.buttons.primary.link.href"
          [target]="content.buttons.primary.link.target || '_self'"
          [wlTrackLink]="content.buttons.primary.link.text"
          [trackLinkInfo]="{
            rendering: rendering,
            field: content.buttons.primary.link.text,
            eventType: 'button-click',
          }"
        >
          {{ content.buttons.primary.link.text }}
        </wl-partial-button>
      </ng-container>
    }
    @if (content?.buttons?.secondary?.link?.href) {
      <ng-container slot="button-secondary">
        <wl-partial-button
          role="link"
          theme="tertiary"
          size="small"
          [fullWidth]="true"
          [ngClass]="content.buttons.secondary.link.class"
          [href]="content.buttons.secondary.link.href"
          [target]="content.buttons.secondary.link.target || '_self'"
          [wlTrackLink]="content.buttons.secondary.link.text"
          [trackLinkInfo]="{
            rendering: rendering,
            field: content.buttons.secondary.link.text,
            eventType: 'button-click',
          }"
        >
          {{ content.buttons.secondary.link.text }}
        </wl-partial-button>
      </ng-container>
    }
  </wl-partial-structured-content>
</wl-partial-media-card>
